var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.75V9C13.5 9.5967 13.2629 10.169 12.841 10.591C12.419 11.0129 11.8467 11.25 11.25 11.25H7.7475L6.15 12.45L4.95 13.35C4.82017 13.4473 4.66228 13.5 4.5 13.5C4.38227 13.5021 4.266 13.4737 4.1625 13.4175C4.03882 13.3552 3.9348 13.2598 3.86199 13.142C3.78918 13.0242 3.75042 12.8885 3.75 12.75V11.25C3.15326 11.25 2.58097 11.0129 2.15901 10.591C1.73705 10.169 1.5 9.5967 1.5 9V3.75C1.5 3.15326 1.73705 2.58097 2.15901 2.15901C2.58097 1.73705 3.15326 1.5 3.75 1.5H11.25C11.8467 1.5 12.419 1.73705 12.841 2.15901C13.2629 2.58097 13.5 3.15326 13.5 3.75Z",
    fill: "#8D8E92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.75V12C16.5 12.5967 16.2629 13.169 15.841 13.591C15.419 14.0129 14.8467 14.25 14.25 14.25V15.75C14.2496 15.8885 14.2109 16.0242 14.138 16.142C14.0652 16.2598 13.9612 16.3552 13.8375 16.4175C13.734 16.4737 13.6178 16.5021 13.5 16.5C13.3377 16.5 13.1798 16.4473 13.05 16.35L10.2525 14.25H6.75C6.30637 14.248 5.87322 14.1149 5.505 13.8675L7.995 12H11.25C12.0457 12 12.8087 11.6839 13.3713 11.1213C13.934 10.5587 14.25 9.79567 14.25 9V4.5C14.8467 4.5 15.419 4.73705 15.841 5.15901C16.2629 5.58097 16.5 6.15326 16.5 6.75Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ea7bf0f368085d46c8aef1b1cc7044d6.svg";
export { ForwardRef as ReactComponent };